export default __webpack_public_path__ + "static/accessibility-cc6b90751d5b571d462359248b7c5db9.png";